import http from "../base";
import { creatUUid, cg_api_signed_body } from "../utils";
import {
  GET_FEED_BY_USER_ID,
  GET_FEED_BY_USERNAME,
  GET_MEDIA_INFO_BY_ID,
  ENABLED_COMMNETS
} from "../constants/path";
import {
  INS_API_FETCH_USER_FEED,
  INS_API_FETCH_USER_FEED_WITH_USER_NAME,
  INS_API_FETCH_MEDIA_INFO,
  INS_API_ENABLE_MEDIA_COMMENTS

  // INS_API_VIEW_MEDIA
} from "../constants/event_consts";
import PresisiteAPIParams from "../persisits/lunch_params";
import { store } from "@/main";
import {
  GETTER_ONE_INS_LOGIN_USER_ID,
  GETTER_API_LOGIN_USER_ID
} from "@/store/constants/ins_user_info_types";
export const getFeedById = async (userId: string, maxId: string = "") => {
  const params: Record<string, string> = {};
  const loginUserId = store.getters[GETTER_API_LOGIN_USER_ID](userId);
  if (maxId) {
    params.max_id = maxId;
    params.session_id = `${loginUserId}_${creatUUid()})`;
  } else {
    params.session_id = creatUUid();
  }
  const navChain =
    "IGMainAppViewController:explore_popular:1,IGExploreViewController:explore_popular:3,IGSearchResultsTabViewController:search_users:5,IGMainAppViewController:profile:1,IGExploreViewController:explore_popular:3,IGProfileViewController:profile:9";

  try {
    const result = await http.get(
      GET_FEED_BY_USER_ID(userId),
      {
        params,
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      { user_id: loginUserId },
      INS_API_FETCH_USER_FEED
    );
    console.log("getFeedById result", result);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const feedUserWithUsername = async (
  username: string,
  maxId: string = ""
) => {
  const params: Record<string, string> = {};
  if (maxId) {
    params.max_id = maxId;
    params.session_id = `userId_${creatUUid()}`;
  } else {
    params.session_id = creatUUid();
  }

  try {
    await http.get(
      GET_FEED_BY_USERNAME(username),
      { params },
      {},
      INS_API_FETCH_USER_FEED_WITH_USER_NAME
    );
  } catch (error) {
    //
  }
};

export const mediaInfo = async (mediaId: string, user_id: string) => {
  const params: Record<string, string> = {};
  const loginUserId = store.getters[GETTER_API_LOGIN_USER_ID](user_id);
  params.session_id = `${loginUserId}_${creatUUid()}`;
  const navChain =
    "IGMainFeedViewController:feed_timeline:1:cold_start,IGDirectInboxViewController:direct_inbox:2:,IGDirectThreadViewController:direct_thread:3:,IGSingleFeedViewController:single_feed:4:";

  try {
    const result = await http.get(
      GET_MEDIA_INFO_BY_ID(mediaId),
      {
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      { user_id: loginUserId },
      INS_API_FETCH_MEDIA_INFO
    );
    console.log("media inof result", result);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const enableComments = async (mediaId: string, user_id: string) => {
  const body: Record<string, string> = {};
  body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  const navChain =
    // tslint:disable-next-line: max-line-length
    "IGProfileViewController:self_profile:2:main_profile,IGContextualFeedViewController:feed_contextual_self_profile:3:";

  try {
    const result = await http.post(
      ENABLED_COMMNETS(mediaId),
      {
        data: cg_api_signed_body(body),
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      { user_id },
      INS_API_ENABLE_MEDIA_COMMENTS
    );
    console.log("enableComments result", result);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};
